import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OnboardDataService {
  private companyNameSource = new BehaviorSubject<string | null>(null);
  private selectedIndustrySource = new BehaviorSubject<string | null>('general');
  
  companyName$ = this.companyNameSource.asObservable();
  selectedIndustry$ = this.selectedIndustrySource.asObservable();

  setCompanyName(name: string) {
    this.companyNameSource.next(name);
  }
  getCompanyName(): string | null {
    return this.companyNameSource.getValue();
  }

  setIndustrySelection(key: string) {
    this.selectedIndustrySource.next(key);
  }
  getSelectedIndustry(): string {
    return this.selectedIndustrySource.getValue();
  }
}
